const PCardActions = require("../../actions/metadata/PCardActions.js");

const PCardData = require("../../types/metadata/PCard.js");

function getUpdatedSpec(originalState, specUpdate) {
    const newSpecData = Object.assign({}, PCardData.GetSpecData(), specUpdate);

    const update = Object.assign({}, originalState.Metadata, {
        CurrentSpec: Object.assign({}, originalState.Metadata.CurrentSpec, {
            Data: newSpecData
        })
    });

    return Object.assign({}, originalState, {
        Metadata: update
    });
}

function getCurrentTargets(originalState) {
    return Object.assign({}, originalState.Metadata.CurrentSpec.Data.Targets);
}

const PCardReducers = {
    [PCardActions.TargetSelected](prev, action) {

        const newSpecData = Object.assign({}, PCardData.GetSpecData(), {
            Arg: JSON.stringify({ "mode": action.mode})
        });

        const result = getUpdatedSpec(prev, newSpecData);

        return result;
    }
};

module.exports = PCardReducers;


// WEBPACK FOOTER //
// ./src/reducers/metadata/PCardReducers.js